/*eslint-disable*/
import DirectionsCarFilledOutlinedIcon from '@mui/icons-material/DirectionsCarFilledOutlined';
import SpeedOutlinedIcon from '@mui/icons-material/SpeedOutlined';
import {
    Box,
    Collapse,
    Drawer,
    Hidden,
    Icon,
    List,
    ListItem,
    ListItemText
} from "@mui/material";
import avatar from "assets/img/default-avatar.png";
import { APP_VERSION } from 'helpers/version';
import PerfectScrollbar from "perfect-scrollbar";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { setQuickQuote } from 'reducers/bookingsReducer';
import AdminNavbarLinks from "../Navbars/AdminNavbarLinks";
import LogoutListItem from './LogoutListItem';
import styles from "./sidebarStyle.js";

var ps;

// We've created this component so we can have a ref to the wrapper of the links that appears in our sidebar.
// This was necessary so that we could initialize PerfectScrollbar on the links.
// There might be something with the Hidden component from material-ui, and we didn't have access to
// the links, and couldn't initialize the plugin.
class SidebarWrapper extends React.Component {
  sidebarWrapper = React.createRef();
  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.sidebarWrapper.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
  }
  render() {
    const { className, sx, user, quickbook, headerLinks, links } = this.props;
    return (
      <Box component={'div'} className={className} sx={sx} ref={this.sidebarWrapper}>
        {user}
        {quickbook}
        {headerLinks}
        {links}
      </Box>
    );
  }
}

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openAvatar: false,
      miniActive: true,
      ...this.getCollapseStates(props.routes),
    };
  }
  mainPanel = React.createRef();
  getCollapseStates = (routes) => {
    let initialState = {};
    routes.map((prop) => {
      if (prop.collapse) {
        initialState = {
          [prop.state]: this.getCollapseInitialState(prop.views),
          ...this.getCollapseStates(prop.views),
          ...initialState,
        };
      }
      return null;
    });
    return initialState;
  };
  // this verifies if any of the collapses should be default opened on a rerender of this component
  // for example, on the refresh of the page,
  // while on the src/views/forms/RegularForms.jsx - route /admin/regular-forms
  getCollapseInitialState(routes) {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && this.getCollapseInitialState(routes[i].views)) {
        return true;
      } else if (window.location.href.indexOf(routes[i].path) !== -1) {
        return true;
      }
    }
    return false;
  }
  // verifies if routeName is the one active (in browser input)
  activeRoute = (routeName) => {
    return window.location.href.indexOf(routeName) > -1 ? "active" : "";
  };
  openCollapse(collapse) {
    var st = {};
    st[collapse] = !this.state[collapse];
    this.setState(st);
  }
  // this function creates the links and collapses that appear in the sidebar (left menu)
  createLinks = (routes) => {
    const { color, rtlActive } = this.props;
    return routes.map((prop, key) => {
      if (prop.redirect) {
        return null;
      }
     
      if (prop.collapse) {
        var st = {};
        st[prop["state"]] = !this.state[prop.state];

        const itemIcon = [styles.itemIcon, rtlActive && styles.itemIconRTL];
        const caret = [
          styles.caret,
          rtlActive && styles.caretRTL,
          this.state[prop.state] && styles.caretActive,
        ];
        const collapseItemMini = [
          styles.collapseItemMini,
          rtlActive && styles.collapseItemTextMiniRTL,
        ];
        return (
          <ListItem
            key={key}
            sx={prop.icon ? styles.item : styles.collapseItem}
          >
            <Box
              components={NavLink}
              to={"#"}
              sx={[styles.itemLink, this.getCollapseInitialState(prop.views) && styles.collapseActive]}
              onClick={(e) => {
                e.preventDefault();
                this.setState(st);
              }}
            >
              {prop.icon !== undefined ? (
                typeof prop.icon === "string" ? (
                  <Icon sx={itemIcon}>{prop.icon}</Icon>
                ) : (
                  <prop.icon sx={itemIcon} />
                )
              ) : (
                <Box component={"span"} sx={collapseItemMini}>
                  {rtlActive ? prop.rtlMini : prop.mini}
                </Box>
              )}
              <ListItemText
                primary={rtlActive ? prop.rtlName : prop.name}
                secondary={<Box component={"b"} sx={caret} />}
                disableTypography={true}
                sx={
                  prop.icon
                    ? [
                        styles.itemText,
                        (this.props.miniActive &&
                          this.state.miniActive) &&
                          styles.itemTextMini,
                        (rtlActive &&
                          this.props.miniActive &&
                          this.state.miniActive) &&
                          styles.itemTextMiniRTL,
                        rtlActive && styles.itemTextRTL,
                      ]
                    : [
                        styles.collapseItemText,
                        (this.props.miniActive &&
                          this.state.miniActive) &&
                          styles.collapseItemTextMini,
                        (rtlActive &&
                          this.props.miniActive &&
                          this.state.miniActive) &&
                          styles.collapseItemTextMiniRTL,
                        rtlActive && styles.collapseItemTextRTL,
                      ]
                }
              />
            </Box>
            <Collapse in={this.state[prop.state]} unmountOnExit>
              <List sx={[styles.list, styles.collapseList]}>
                {this.createLinks(prop.views)}
              </List>
            </Collapse>
          </ListItem>
        );
      }

      const innerNavLinkClasses = this.activeRoute(prop.path) ? {
        ...styles.collapseItemLink,
        ...styles[color],
      } : {...styles.collapseItemLink}

      const collapseItemMini = [
        styles.collapseItemMini,
        rtlActive && styles.collapseItemTextMiniRTL,
      ];
      
      const navLinkClasses = this.activeRoute(prop.path) ? {
        ...styles.itemLink,
        ...styles[color],
    } : {...styles.itemLink,} ;

    
      const itemText = [
        styles.itemText,
        this.props.miniActive && this.state.miniActive && styles.itemTextMini,
        rtlActive &&
          this.props.miniActive &&
          this.state.miniActive &&
          styles.itemTextMiniRTL,
        rtlActive && styles.itemTextRTL,
      ];

      const collapseItemText = [
        styles.collapseItemText,
        this.props.miniActive &&
          this.state.miniActive &&
          styles.collapseItemTextMini,
        rtlActive &&
          this.props.miniActive &&
          this.state.miniActive &&
          styles.collapseItemTextMiniRTL,
        rtlActive && styles.collapseItemTextRTL,
      ];

      const itemIcon = [styles.itemIcon, rtlActive && styles.itemIconRTL];

      return (
        <ListItem
          key={key}
          sx={prop.icon == null ? styles.collapseItem : styles.item}
        >
          <Box 
            component={NavLink}
            to={prop.layout + prop.path}
            sx={prop.icon == null ? innerNavLinkClasses : navLinkClasses}
          >
            {prop.icon !== undefined ? (
              typeof prop.icon === "string" ? (
                <Icon sx={itemIcon}>{prop.icon}</Icon>
              ) : (
                <Box component={prop.icon} sx={itemIcon} />
              )
            ) : (
              <Box component={"span"} sx={collapseItemMini}>
                {rtlActive ? prop.rtlMini : prop.mini}
              </Box>
            )}
            <ListItemText
              primary={rtlActive ? prop.rtlName : prop.name}
              disableTypography={true}
              sx={prop.icon == null ? collapseItemText : itemText}
            />
          </Box>
        </ListItem>
      );
    });
  };
  
  render() {
    const { logo, image, logoText, routes, bgColor, rtlActive } =
      this.props;

    const itemText = [
      styles.itemText,
      rtlActive && styles.itemTextRTL,
      this.props.miniActive && this.state.miniActive && styles.itemTextMini,
      rtlActive &&
        this.props.miniActive &&
        this.state.miniActive &&
        styles.itemTextMiniRTL,
    ];


    const collapseItemText = [
      styles.collapseItemText,
      rtlActive && styles.collapseItemTextRTL,
      this.props.miniActive &&
        this.state.miniActive &&
        styles.collapseItemTextMini,
      rtlActive &&
        this.props.miniActive &&
        this.state.miniActive &&
        styles.collapseItemTextMiniRTL,
    ];

    const userWrapperClass = [
      styles.user,
      bgColor === "white" && styles.whiteAfter,
    ];

    const caret = [styles.caret, rtlActive && styles.caretRTL];

    const collapseItemMini = [
      styles.collapseItemMini,
      rtlActive && styles.collapseItemMiniRTL,
    ];

    const photo = [styles.photo, rtlActive && styles.photoRTL];
    
    var user = (
      <Box component={"div"} sx={userWrapperClass}>
        <Box component={"div"} sx={photo}>
          <Box
            component={"img"}
            src={avatar}
            sx={styles.avatarImg}
            alt="..."
          />
        </Box>
        <List sx={styles.list}>
          <ListItem sx={[styles.item, styles.userItem]}>
            <Box
              component={
                NavLink
              }
              to={"#"}
              sx={[styles.itemLink, styles.userCollapseButton]}
              onClick={(e) => {
                e.preventDefault();
                this.openCollapse("openAvatar");
              }}
            >
              <ListItemText
                primary={
                  rtlActive
                    ? "تانيا أندرو"
                    : `${this.props.userDetails.firstName} ${this.props.userDetails.lastName}`
                }
                secondary={
                  <Box component={'b'}
                    sx={[
                      ...caret,
                      styles.userCaret,
                      this.state.openAvatar && styles.caretActive
                    ]}
                  />
                }
                disableTypography={true}
                sx={[...itemText, styles.userItemText]}
              />
            </Box>
            <Collapse in={this.state.openAvatar} unmountOnExit>
              <List sx={[styles.list, styles.collapseList]}>
                <ListItem sx={styles.collapseItem}>
                  <Box
                    component={NavLink}
                    to="/admin/profile"
                    sx={[styles.itemLink, styles.userCollapseLinks]}
                  >
                    {/* <Box component={'span'} sx={collapseItemMini}>
                      {rtlActive ? "مع" : "MP"}
                    </Box> */}
                    <ListItemText
                      primary={rtlActive ? "ملفي" : "My Profile"}
                      disableTypography={true}
                      sx={collapseItemText}
                    />
                  </Box>
                  <Box
                    component={'label'}
                    sx={[styles.itemLink, styles.userCollapseLinks]}
                    style={{ cursor: 'pointer' }}
                  >
                    <LogoutListItem styling={collapseItemText} rtlActive={rtlActive} />
                  </Box>
                </ListItem>
              </List>
            </Collapse>
          </ListItem>
        </List>
      </Box>
    );

    const quickbook = () => {
      const currentUserRoles = this.props.userDetails.roles.map((x) => {
        return x.toUpperCase()
      })

      const validateAccess = (requiredRole) => {
        const targetRole = requiredRole.toUpperCase()
        return currentUserRoles.includes(targetRole)
      }

      const hasAccess = validateAccess('JYRNEY_ADMIN') 
      || validateAccess('OPERATIONS_SUPPORT') 
      || validateAccess('OPERATIONS_SUPPORT_SUPERVISOR')
      || validateAccess('FINANCE')
      || validateAccess('CLIENT_ADMIN')
      || validateAccess('TRAVEL_CONSULTANT')
      || validateAccess('SENIOR_TRAVEL_CONSULTANT')
      || validateAccess('TRAVELLER')
      
      if(hasAccess) {
        return (
          <>
          <Box
            component={NavLink}
            to={'/admin/bookings/create?new=true&bookingType=qq'}
            onClick={() => this.props.inputQuickQuote(true)}
            sx={[
              styles.makeABooking,
              { 
                maxWidth: this.props.miniActive && this.state.miniActive ? '60%' : '80%',
              },
            ]}
          >
            <SpeedOutlinedIcon />
            {this.props.miniActive && this.state.miniActive
              ? null
              : (
                <Box
                  component="span"
                  sx={{
                    width: '100%',
                    fontFamily: (theme) =>
                      theme.typography.fontFamilyDisplay ||
                      theme.typography.fontFamily,
                    textTransform: 'uppercase',
                  }}
                >
                  Quick Quote
                </Box>
              )}
          </Box>
          <Box
            component={NavLink}
            to={'/admin/bookings/create?new=true'}
            onClick={() => this.props.inputQuickQuote(false)}
            sx={[
              styles.makeABooking,
              { 
                maxWidth: this.props.miniActive && this.state.miniActive ? '60%' : '80%',
              },
            ]}
          >
            <DirectionsCarFilledOutlinedIcon />
            {this.props.miniActive && this.state.miniActive
              ? null
              : (
                <Box
                  component="span"
                  sx={{
                    width: '100%',
                    fontFamily: (theme) =>
                      theme.typography.fontFamilyDisplay ||
                      theme.typography.fontFamily,
                    textTransform: 'uppercase',
                  }}
                >
                  Book Now
                </Box>
              )}
          </Box>
          </>
          )
      }

    };

    var links = (
      <List sx={styles.list}>{this.createLinks(routes)}</List>
    );

    const logoNormal = [
      styles.logoNormal,
      this.props.miniActive && this.state.miniActive && styles.logoNormalSidebarMini,
      rtlActive && this.props.miniActive && this.state.miniActive && styles.logoNormalSidebarMiniRTL,
      rtlActive && styles.logoNormalRTL,
    ]
    
    const logoMini = [
      styles.logoMini,
      rtlActive && styles.logoMiniRTL,
      this.props.logoNoPadding && { marginLeft: 0, marginRight: 0, width: '100%' },
    ]
    const logoClasses = [
      styles.logo,
      bgColor === "white" && styles.whiteAfter,
      this.props.logoNoPadding && { padding: 0 },
    ]

    var brand = (
      <Box component={'div'} sx={logoClasses}>
        <Box
          component={'a'}
          href={location.origin}
          target="_blank"
          sx={logoMini}
        >
          <Box
            component={'img'}
            src={logo}
            alt="logo"
            sx={[styles.img, this.props.logoNoPadding && { paddingX: 0, width: '100%' }]}
          />
        </Box>
        <Box
          component={'a'}
          href={process.env.REACT_APP_WEBSITE_URL}
          target="_blank"
          sx={logoNormal}
        >
          {logoText}
        </Box>
      </Box>
    );
    const versionLabel = APP_VERSION ? (
      <Box
        component={'span'}
        sx={{
          position: 'absolute',
          bottom: '6px',
          right: '10px',
          zIndex: 5,
          fontSize: '0.6rem',
          lineHeight: 1,
          letterSpacing: '0.02em',
          color: 'rgba(255, 255, 255, 0.5)',
          pointerEvents: 'none',
          userSelect: 'none',
        }}
      >
        v{APP_VERSION}
      </Box>
    ) : null;

    const drawerPaper = [
      styles.drawerPaper,
      this.props.miniActive && this.state.miniActive && styles.drawerPaperMini,
      rtlActive && styles.drawerPaperRTL,
    ]

    const sidebarWrapper = [
      styles.sidebarWrapper,  
      this.props.miniActive && this.state.miniActive && styles.drawerPaperMini,
      navigator.platform.indexOf("Win") > -1 && styles.sidebarWrapperWithPerfectScrollbar,
    ]

    return (
      <div ref={this.mainPanel}>
        <Hidden mdUp implementation="css">
          <Drawer
            variant="temporary"
            anchor={rtlActive ? "left" : "right"}
            open={this.props.open}
            PaperProps={{
              sx: [...drawerPaper, styles.overlay]
            }}
            onClose={this.props.handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {brand}
            <SidebarWrapper
              sx={sidebarWrapper}
              user={user}
              quickbook={quickbook()}
              headerLinks={<AdminNavbarLinks rtlActive={rtlActive} />}
              links={links}
              />
            {image !== undefined ? (
              <Box 
                component={'div'}
                sx={styles.background}
                style={{ backgroundImage: "url(" + image + ")" }}
              />
            ) : null}
            {versionLabel}
          </Drawer>
        </Hidden>
        <Hidden mdDown implementation="css">
          <Drawer
            onMouseOver={() => this.setState({ miniActive: false })}
            onMouseOut={() => this.setState({ miniActive: true })}
            anchor={rtlActive ? "right" : "left"}
            variant="permanent"
            open
            PaperProps={{
              sx: [...drawerPaper, styles.overlay]
            }}
          >
            {brand}
            <SidebarWrapper
              sx={sidebarWrapper}
              user={user}
              quickbook={quickbook()}
              links={links}
            />
            {image !== undefined ? (
              <Box
                component={'div'}
                sx={styles.background}
                style={{ backgroundImage: "url(" + image + ")" }}
              />
            ) : null}
            {versionLabel}
          </Drawer>
        </Hidden>
      </div>
    );
  }
}

Sidebar.defaultProps = {
  bgColor: "blue",
};

Sidebar.propTypes = {
  bgColor: PropTypes.oneOf(["white", "black", "blue"]),
  rtlActive: PropTypes.bool,
  color: PropTypes.oneOf([
    "white",
    "red",
    "orange",
    "green",
    "blue",
    "purple",
    "rose",
    "custom",
  ]),
  logo: PropTypes.string,
  logoText: PropTypes.string,
  image: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  miniActive: PropTypes.bool,
  open: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
};

SidebarWrapper.propTypes = {
  className: PropTypes.string,
  user: PropTypes.object,
  headerLinks: PropTypes.object,
  links: PropTypes.object,
};

const mapStateToProps = (state) => ({
  userDetails: state.users.user,
});

const mapDispatchToProps = ({
  inputQuickQuote: setQuickQuote,
})

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
